module.exports = __webpack_public_path__ + "img/refresh-page-option.78828d0e.svg";